import { Auth } from 'aws-amplify';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import config from '../config';

const { userPoolId, userPoolWebClientId } = config;

export const refreshCognitoSession = async () => {
    try {
        const session = await Auth.currentSession();
        if (session?.isValid()) {
            return session;
        }
    } catch (error) {
        // Fall through to explicit refresh via Cognito SDK.
    }

    const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: userPoolWebClientId,
    });
    const cognitoUser = userPool.getCurrentUser();

    if (!cognitoUser) {
        throw new Error('No authenticated user');
    }

    return new Promise((resolve, reject) => {
        cognitoUser.getSession((err, session) => {
            if (err) {
                reject(err);
                return;
            }
            resolve(session);
        });
    });
};

export const getIdToken = async () => {
    const session = await refreshCognitoSession();
    return session.getIdToken().jwtToken;
};
